import createCrudModule from 'vuex-crud';
import Vue from 'vue';

export default createCrudModule({
  resource: 'enumItems',
  urlRoot: 'enum-items',
  parseList(response) {
    const { data } = response;

    return Object.assign({}, response, {
      data: data.data, // expecting array of objects with IDs
    });
  },
  customUrlFn(id, type, resId) {
    // id will only be available when doing request to single resource, otherwise null
    // type is the actions you are dispatching: FETCH_LIST, FETCH_SINGLE, CREATE, UPDATE, REPLACE, DESTROY
    let rootUrl2;
    const baseUrl = 'enum-items';
    if (id) {
      return `${baseUrl}/${id}`;
    }
    if (type === 'FETCH_LIST' && resId && (resId.parentId || resId.filters)) {
      rootUrl2 = `/${baseUrl}`; // `/clients/contacts/`;
      let filterUrl = '?';

      if (typeof resId.filters !== 'undefined') {
        resId.filters.forEach((item, i) => {
          filterUrl = `${filterUrl + ((i === 0) ? '' : '&')}filters[${item.field}]` + `=${item.value}&`;
        });
        rootUrl2 += filterUrl;
      }

      return id ? `rootUrl/${id}` : rootUrl2;
    }
    return baseUrl;
  },
  onReplaceSuccess(state, response, xx) {
    // console.log(xx);
    // dispatch('crud/SET_SNACKBAR');
  },
  onCreateSuccess(state, response) {
    const { data } = response;
    const id = data.id.toString();

    const listIndex = state.list.indexOf(id);
    if (listIndex < 0) {
      state.list.push(id);
    }
  },
});
